import { render, staticRenderFns } from "./InsightsHelp.vue?vue&type=template&id=14872151&scoped=true&"
import script from "./InsightsHelp.vue?vue&type=script&lang=js&"
export * from "./InsightsHelp.vue?vue&type=script&lang=js&"
import style0 from "./InsightsHelp.vue?vue&type=style&index=0&id=14872151&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14872151",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
